import React, {useState, useEffect, useMemo} from 'react';
import Paper from '@mui/material/Paper';
import { Typography } from 'antd';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useMode } from 'src/hooks/ModeContext';
import moment from 'moment';
import serverApi from '../../api/server';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import generateSignature from '../../api/apiAuth'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Range, getTrackBackground } from 'react-range';
import { CSVLink } from "react-csv";
const { Title, Text } = Typography;
function ExternalWalletTransactionTable() {
    const [transactionData, setTransactionData] = useState<any[]>([]);
    const [tradeData, setTradeData] = useState<any[]>([]);
    const [searchTXValue, setSearchTXValue] = useState('');
    const [searchTradeTXValue, setSearchTradeTXValue] = useState('');

    const [openFilter, setOpenFilter] = useState(false);
    const [filterName, setFilterName] = useState('');
    const [filterTradeName, setFilterTradeName] = useState('');
    const [filterAsset, setFilterAsset] = useState('');
    const [filterTradeAsset, setFilterTradeAsset] = useState('');
    const [filterTradeCounterAsset, setFilterTradeCounterAsset] = useState('')
    const [filterTxType, setFilterTxType] = useState('');
    const [filterDateStart, setFilterDateStart] = useState(null);
    const [filterDateStartTrade, setFilterDateStartTrade] = useState(null);
    const [filterDateEnd, setFilterDateEnd] = useState(null);
    const [filterDateEndTrade, setFilterDateEndTrade] = useState(null);

    const [filterTradeOrderType, setFilterTradeOrderType] = useState('');
    const [filterTradeSide, setFilterTradeSide] = useState('');
    const [loading, setLoading] = useState(false);
    const [curTxIndex, setCurTxIndex] = useState();

    const [maxAmount, setMaxAmount] = useState<number>(0);
    const [minAmount, setMinAmount] = useState<number>(0);
    const [filterAmount, setFilterAmount] = useState<number[]>([0,0])
    const [maxAmountTrade, setMaxAmountTrade] = useState(0);
    const [minAmountTrade, setMinAmountTrade] = useState(0);
    const [filterTradeAmount, setFilterTradeAmount] = useState<number[]>([0,0])
    const [state, action] = useMode();
    const [currentTxMode, setCurrentTxMode] = useState('trades')
    const getExternalWalletTransactionData = async() : Promise<any> => {
        try {
            let resultJSONData;
            // if(state.mode === 'sdm') {
            //     console.log(state.mode)
            // }


            const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            const query = state.mode.toUpperCase()
            const path = `/api/getExtTransactions?unit=${query}`

            const signature = generateSignature("GET", timeStamp, path, query, null) 

            const result = await serverApi.get('/getExtTransactions?unit=' + state.mode.toUpperCase(), {headers: {Authorization: signature}})
            console.log(result)
            resultJSONData = result.data
            console.log(resultJSONData)
            return {
                deposits: resultJSONData.Deposits,
                trades: resultJSONData.Trades
            }
        }
        catch (err) {
            alert(err)
            return {
                deposits: [],
                trades: []
            }
        }
    }
    useEffect(() => {
        //Filter options updated so apply all filters here
        //let result = transactions
        
        getExternalWalletTransactionData().then((res:any) => {
            setLoading(true)
            console.log(res)
            let result: any[] = res.deposits
            let tradeResult: any[] = res.trades
            console.log(result)
            console.log(tradeResult)
            if(result) {
                let amountArr = result.map((i: any) => i.Amount)
                console.log(amountArr)
                let highest = Math.max(...amountArr)
                let lowest = Math.min(...amountArr)
                console.log(highest);
                console.log(lowest);
                if(amountArr.length === 0){
                    setMinAmount(0)
                    setMaxAmount(0)
                }
                else if (highest === lowest && lowest > 0){
                    // setAmountRangeFilter([0, highest])
                    // setAmountRange([0, highest])
                    setMinAmount(0)
                    setMaxAmount(highest)
                }
                else {
                    // setAmountRangeFilter([lowest, highest])
                    setMinAmount(lowest)
                    setMaxAmount(highest)
                }
                if(searchTXValue) {
                    result = result.filter((i: any) => (i.Address).toUpperCase().includes(searchTXValue.toUpperCase()))
                }
                if(filterName) {
                    result = filterWithName(result, filterName);
                }
                if(filterAsset) {
                    result = filterWithAsset(result, filterAsset)
                }
                if(filterDateStart && filterDateEnd) {
                    result = filterWithDateRangeDeposit(result)
                    console.log(result)
                }
                if(filterTxType) {
                    result = result.filter((i: any) => i.TransType === filterTxType)
                }
                setTransactionData(result);
                
            }
            if(tradeResult) {
                
                if(searchTradeTXValue) {
                    tradeResult = tradeResult.filter((i: any) => (i._id).toUpperCase().includes(searchTradeTXValue.toUpperCase()))
                }
                if(filterTradeName) {
                    tradeResult = filterWithUsername(tradeResult, filterTradeName);
                }
                if(filterDateStartTrade && filterDateEndTrade) {
                    tradeResult = filterWithDateRange(tradeResult)
                }
                if(filterTradeAsset) {
                    tradeResult = filterWithTradeAsset(tradeResult, filterTradeAsset)
                }
                if(filterTradeCounterAsset) {
                    tradeResult = filterWithTradeCounterAsset(tradeResult, filterTradeCounterAsset)
                }
                if(filterTradeOrderType) {
                    tradeResult = tradeResult.filter(td => td.orderType = filterTradeOrderType)
                }
                if(filterTradeSide) {
                    tradeResult = tradeResult.filter(td => td.side = filterTradeSide)
                }
                console.log(tradeResult);
                
                setTradeData(tradeResult);
            }
            setLoading(false)
        });
    }, [searchTXValue, state.mode, filterName, filterDateStart,filterDateEnd, 
        searchTradeTXValue, filterTradeName, filterDateStartTrade, filterDateEndTrade,
        filterAsset, filterTxType, filterTradeAsset, filterTradeCounterAsset, filterTradeOrderType, filterTradeSide]);
    useMemo(() => {
        if(maxAmount){
            setFilterAmount([minAmount, maxAmount])
        }
    },[maxAmount])
    const filterWithTradeAsset = (arr: any[], assetName: string) => {
        return arr.filter(item => item.asset === assetName)
    }
    const filterWithTradeCounterAsset = (arr: any[], assetName: string) => {
        return arr.filter(item => item.counterAsset === assetName)
    }
    const filterWithName = (arr: any[], assetName: string) => {
        return arr.filter(item => item.Name === assetName);
    }
    const filterWithUsername = (arr: any[], assetName: string) => {
        return arr.filter(item => item.user.firstName + " " + item.user.lastName === assetName);
    }
    const filterWithAsset = (arr: any[], assetName: string) => {
        return arr.filter(item => item.Asset === assetName);
    }
    // const filterWithSource = (arr: any[], source: string) => {
    //     return arr.filter(item => item.source.name === source);
    // }
    const filterWithDateRange = (arr: any[]) => {
        return filterDateStartTrade && filterDateEndTrade? arr.filter(item => moment(item.createdAt).isSameOrAfter(filterDateStartTrade, 'day') && moment(item.createdAt).isSameOrBefore(filterDateEndTrade)) : arr;
    }
    const filterWithDateRangeDeposit = (arr: any[]) => {
        return filterDateStart && filterDateEnd? arr.filter(item => moment(item.Date).isSameOrAfter(filterDateStart, 'day') && moment(item.Date).isSameOrBefore(filterDateEnd)) : arr;

    }
    // const handleSourceFilterChange = (event: any) => {
    //     setFilterSource(event.target.value)
    // }
    const handleSearchTXAddress = (e:any) => {
        let inputValue = (e.target.value).trim()
        setSearchTXValue(inputValue)
        // let 
        // console.log(result)
        // setSearchTXResult(result)
    }
    const handleSearchTradeTxId = (e:any) => {
        let inputValue = (e.target.value).trim()
        setSearchTradeTXValue(inputValue)
    }
    const handleClickClearTransactionSearchInput = () => {
        setSearchTXValue('')
        setSearchTradeTXValue('')
    }
    const handleNameFilterChange = (event:any) => {
        setFilterName(event.target.value)
    }
    const handleFilterAssetChange = (event:any) =>{
        setFilterAsset(event.target.value)
    }
    const handleFilterTxTypeChange = (event:any) => {
        setFilterTxType(event.target.value)
    }   
    const handleTradeNameFilterChange = (event:any) => {
        setFilterTradeName(event.target.value)
    }
    const clearFilters = () => {
        // setFilterVault('');
        setFilterName('')
        setFilterAsset('')
        setFilterTxType('')
        // setFilterSource('')
        setFilterDateStart(null)
        setFilterDateEnd(null);
        setFilterAmount([minAmount, maxAmount])
        // setTransactionData(transactions)
    }
    const clearTradeFilters = () => {
        setFilterTradeName('')
        // setFilterSource('')
        setFilterDateStartTrade(null)
        setFilterDateEndTrade(null)
        setFilterTradeAsset('')
        setFilterTradeCounterAsset('')
        setFilterTradeSide('')
    }
    const closeFilterMenu = () => {
        setOpenFilter(false)
    }
    const openFilterMenu = () => {
        setOpenFilter(true)
    }
    // const handleOpenTxInfoDialog = (row: any, index: any) => {
    //     setTxData(row)
    //     setCurTxIndex(index)
    //     setOpenTxInfo(true)
    // }
    const changeCurrentTxMode = () => {
        if(currentTxMode === 'deposits') {
            setCurrentTxMode('trades')
            clearFilters()
        }
        else {
            setCurrentTxMode('deposits')
            clearTradeFilters()
        }
    }
    const handleFilterAmountChange = (values: number[]) => {
        console.log(values)
        setFilterAmount(values)
    }
    const handleFilterTradeAssetChange = (e:any) => {
        setFilterTradeAsset(e.target.value)
    }
    const handleTradeCounterAssetChange = (e:any) => {
        setFilterTradeCounterAsset(e.target.value)
    }
    const handleFilterTradeOrderTypeChange = (e:any) => {
        setFilterTradeOrderType(e.target.value)
    }
    const handleTradeSideChange = (e:any) => {
        setFilterTradeSide(e.target.value)
    }
    return (
        <>
        <div style={{marginBottom: '5px'}}>
            <Button variant="text" color="info" onClick={() => changeCurrentTxMode()}>{currentTxMode === 'deposits' ? 'Show trades transactions' : 'Show deposits transactions'}</Button>
        </div>
        {currentTxMode === 'deposits' ?
        <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <Paper
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 200, height: 36 ,marginBottom: 1, marginRight: 5 }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            value={searchTXValue}
                            onChange={(e) => handleSearchTXAddress(e)}
                            placeholder="Search Address"
                            inputProps={{ 'aria-label': 'search client' }}
                            // startAdornment={<SearchIcon /> }
                            endAdornment={searchTXValue? 
                                <InputAdornment position="end">
                                    <IconButton
                                        size='small'
                                        onClick={handleClickClearTransactionSearchInput}
                                        style={{borderRadius: 0}}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    </InputAdornment> : <SearchIcon />}
                                />
                            </Paper>
                            {openFilter? 
                                <Paper elevation={2} sx={{flexDirection: 'column', marginBottom: 5, minHeight: 50, padding: 2, paddingX: 3, paddingY: 1.5}}>
                                    <div style={{ display: 'inline-flex',flexDirection: 'row'}}>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterName}
                                                label="Name"
                                                onChange={handleNameFilterChange}
                                            >
                                                {transactionData && Array.from(new Set(transactionData.map(item => item.Name))).map(item =>  
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Asset</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterAsset}
                                                label="Asset"
                                                onChange={handleFilterAssetChange}
                                            >
                                                {transactionData && Array.from(new Set(transactionData.map(tag => tag.Asset))).map(item => 
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Tx Type</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterTxType}
                                                label="Asset"
                                                onChange={handleFilterTxTypeChange}
                                            >
                                                {transactionData && Array.from(new Set(transactionData.map(tag => tag.TransType))).map(item => 
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'column', marginTop: 8}}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="From"
                                                value={filterDateStart}
                                                onChange={(newValue: any) => {
                                                    setFilterDateStart(newValue);
                                                }}
                                                maxDate={filterDateEnd ? filterDateEnd : null}
                                                renderInput={(params) => <TextField {...params} size="small"/>}
                                            />
                                        </LocalizationProvider>
                                        <span style={{margin: 5, textAlign: 'center'}}></span>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="To"
                                                value={filterDateEnd}
                                                onChange={(newValue: any) => {
                                                    setFilterDateEnd(newValue);
                                                }}
                                                minDate={filterDateStart ? filterDateStart : null}
                                                renderInput={(params) => <TextField {...params} size="small"/>}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <Button sx={{marginLeft: 5, height: 30, alignSelf: 'center'}} variant="text" size="small" onClick={() => clearFilters()} 
                                        disabled={!(filterName || filterDateStart || filterDateEnd || filterAsset || filterTxType) &&  (filterAmount[0] === minAmount && filterAmount[1] === maxAmount)}>
                                            clear filter
                                    </Button>
                                    <IconButton
                                        aria-label="expand row"
                                        sx={{marginLeft: 5, height: 40, alignSelf: 'start'}}
                                        onClick={() => closeFilterMenu()}
                                    >
                                        <CloseIcon/>
                                    </IconButton>
                                    </div>
                                    <div style={{margin: 15, marginTop: 33}}>
                                        <Range
                                            min={minAmount}
                                            max={maxAmount}
                                            values={filterAmount}
                                            step={maxAmount/100}
                                            onChange={(values) => handleFilterAmountChange(values)}
                                            disabled={minAmount === maxAmount}
                                            renderTrack={({ props, children }) => (
                                                <div
                                                    onMouseDown={props.onMouseDown}
                                                    onTouchStart={props.onTouchStart}
                                                    style={{
                                                        ...props.style,
                                                        height: '36px',
                                                        display: 'flex',
                                                        width: '100%'
                                                    }}
                                                >
                                                    <div
                                                        ref={props.ref}
                                                        style={{
                                                        height: '5px',
                                                        width: '100%',
                                                        borderRadius: '4px',
                                                        background: getTrackBackground({
                                                            values: filterAmount,
                                                            colors: ['#ccc', '#548BF4', '#ccc'],
                                                            min: minAmount,
                                                            max: maxAmount,
                                                        }),
                                                        alignSelf: 'center'
                                                        }}
                                                    >
                                                        {children}
                                                    </div>
                                                </div>
                                            )}
                                            renderThumb={({ index, props, isDragged }) => (
                                                <div
                                                    {...props}
                                                    style={{
                                                        ...props.style,
                                                        height: '42px',
                                                        width: '42px',
                                                        borderRadius: '4px',
                                                        backgroundColor: '#FFF',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        boxShadow: '0px 2px 6px #AAA'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                        position: 'absolute',
                                                        top: '-28px',
                                                        color: '#fff',
                                                        fontWeight: 'bold',
                                                        fontSize: '14px',
                                                        fontFamily: 'Arial,Helvetica Neue,Helvetica,sans-serif',
                                                        padding: '4px',
                                                        borderRadius: '4px',
                                                        backgroundColor: '#548BF4'
                                                        }}
                                                    >
                                                        {filterAmount[index].toFixed(4)}
                                                    </div>
                                                    <div
                                                        style={{
                                                        height: '16px',
                                                        width: '5px',
                                                        backgroundColor: isDragged ? '#548BF4' : '#CCC'
                                                        }}
                                                    />
                                                    </div>
                                                )}
                                            />
                                    </div>
                                </Paper> : <Button variant="text" size="small" onClick={() => openFilterMenu()}>open filter</Button>}
                                
                                </div>
                                <div style={{justifySelf: 'flex-end'}}>
                                    <CSVLink
                                        asyncOnClick={true}
                                        // onClick={(event, done) => exportToCsv(asset, event, done)}
                                        style={{ color: "#000", height: '30px', textAlign: 'center' }}
                                        filename={'all_deposit_transaction.csv'}
                                        data={transactionData}
                                    >
                                        Download Transactions Report
                                    </CSVLink>
                                </div>
                                {/* <Button style={{justifySelf: 'flex-end'}} disabled={!transactionData || (transactionData && transactionData.length === 0)} startIcon={<FileDownloadIcon />} onClick={() => downloadAuditReport()}>
                                    Download Audit report
                                </Button> */}
                            </div>
                            <div className='fireblockTransactionContainer'>
                                <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                                    {loading ? <LinearProgress color="success"/> : null}
                                    <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Title level={3}>Date</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Tx Type</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Name</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Asset</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Address</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Amount</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Tx ID</Title></TableCell>
                                            <TableCell align="left"/>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {transactionData && transactionData
                                    .filter((td:any) => td.Amount <= filterAmount[1] && td.Amount >= filterAmount[0])
                                    //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={index} selected={curTxIndex === index}>
                                            <TableCell>{moment(row.Date).format('L')}</TableCell>
                                            <TableCell align='left'>{row.TransType}</TableCell>
                                            <TableCell align='left'>{row.Name}</TableCell>
                                            <TableCell align='left'>{row.Asset}</TableCell>
                                            <Tooltip title={row.Address} placement="top"><TableCell align='left'>{row.Address.substr(0, 7) + '...' + row.Address.substr(row.Address.length-7, row.Address.length)}</TableCell></Tooltip>
                                            <TableCell align='left'>{row.Amount}</TableCell>
                                            <TableCell align='left'>{row.TxID}</TableCell>
                                            <TableCell align='left'>
                                            {/* <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => handleOpenTxInfoDialog(row, index)}
                                            >
                                                <InfoIcon color="success"/>
                                            </IconButton> */}
                                            </TableCell>
                                        </TableRow>
                                        )
                                    )}
                                </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
        </div>:<div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <Paper
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 200, height: 36 ,marginBottom: 1, marginRight: 5 }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            value={searchTradeTXValue}
                            onChange={(e) => handleSearchTradeTxId(e)}
                            placeholder="Search Trade ID"
                            inputProps={{ 'aria-label': 'search client' }}
                            // startAdornment={<SearchIcon /> }
                            endAdornment={searchTradeTXValue? 
                                <InputAdornment position="end">
                                    <IconButton
                                        size='small'
                                        onClick={handleClickClearTransactionSearchInput}
                                        style={{borderRadius: 0}}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    </InputAdornment> : <SearchIcon />}
                                />
                            </Paper>
                            {openFilter? 
                                <Paper elevation={2} sx={{display: 'inline-flex', flexDirection: 'row', marginBottom: 5, minHeight: 50, padding: 2, paddingX: 3, paddingY: 1.5}}>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterTradeName}
                                                label="Name"
                                                onChange={handleTradeNameFilterChange}
                                            >
                                                {tradeData && Array.from(new Set(tradeData.map(item => item.user.firstName + " " + item.user.lastName))).map(item =>  
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Asset</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterTradeAsset}
                                                label="Source"
                                                onChange={handleFilterTradeAssetChange}
                                            >
                                                {tradeData && Array.from(new Set(tradeData.map(tag => tag.asset))).map(item => 
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Counter Asset</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterTradeCounterAsset}
                                                label="Counter Asset"
                                                onChange={handleTradeCounterAssetChange}
                                            >
                                                {tradeData && Array.from(new Set(tradeData.map(tag => tag.counterAsset))).map(item => 
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Side</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterTradeSide}
                                                label="Counter Asset"
                                                onChange={handleTradeSideChange}
                                            >
                                                {tradeData && Array.from(new Set(tradeData.map(tag => tag.side))).map(item => 
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'column', marginTop: 8}}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="From"
                                                value={filterDateStartTrade}
                                                onChange={(newValue: any) => {
                                                    setFilterDateStartTrade(newValue);
                                                }}
                                                maxDate={filterDateEndTrade ? filterDateEndTrade : null}
                                                renderInput={(params) => <TextField {...params} size="small"/>}
                                            />
                                        </LocalizationProvider>
                                        <span style={{margin: 5, textAlign: 'center'}}></span>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="To"
                                                value={filterDateEndTrade}
                                                onChange={(newValue: any) => {
                                                    setFilterDateEndTrade(newValue);
                                                }}
                                                minDate={filterDateStartTrade ? filterDateStartTrade : null}
                                                renderInput={(params) => <TextField {...params} size="small"/>}
                                            />
                                        </LocalizationProvider>
                                        <FormControl sx={{ minWidth: 120, marginRight: 3, marginTop: 1 }} size="small">
                                            <InputLabel id="demo-select-small">Order Type</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={filterTradeOrderType}
                                                label="Source"
                                                onChange={handleFilterTradeOrderTypeChange}
                                            >
                                                {tradeData && Array.from(new Set(tradeData.map(tag => tag.orderType))).map(item => 
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <Button sx={{marginLeft: 5, height: 30, alignSelf: 'center'}} variant="text" size="small" onClick={() => clearTradeFilters()} 
                                        disabled={!(filterTradeName || filterDateStartTrade || filterDateEndTrade || filterTradeAsset || filterTradeCounterAsset || filterTradeOrderType || filterTradeSide)}>clear filter</Button>
                                    <IconButton
                                        aria-label="expand row"
                                        sx={{marginLeft: 5, height: 40, alignSelf: 'start'}}
                                        onClick={() => closeFilterMenu()}
                                    >
                                        <CloseIcon/>
                                    </IconButton>
                                </Paper> : <Button variant="text" size="small" onClick={() => openFilterMenu()}>open filter</Button>}
                                
                                </div>
                                <div style={{justifySelf: 'flex-end'}}>
                                    <CSVLink
                                        asyncOnClick={true}
                                        // onClick={(event, done) => exportToCsv(asset, event, done)}
                                        style={{ color: "#000", height: '30px', textAlign: 'center' }}
                                        filename={'all_trade_transaction.csv'}
                                        data={tradeData}
                                    >
                                        Download Transactions Report
                                    </CSVLink>
                                </div>
                                {/* <Button style={{justifySelf: 'flex-end'}} disabled={!transactionData || (transactionData && transactionData.length === 0)} startIcon={<FileDownloadIcon />} onClick={() => downloadAuditReport()}>
                                    Download Audit report
                                </Button> */}
                            </div>
                            <div className='fireblockTransactionContainer'>
                                <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                                    {loading ? <LinearProgress color="success"/> : null}
                                    <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Title level={3}>Date</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Tx ID</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>User</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Asset</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Counter Asset</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Limit Price</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Order Type</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Price</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Quantity</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Side</Title></TableCell>
                                            <TableCell align="left"><Title level={3}>Status</Title></TableCell>
                                            <TableCell align="left"/>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {tradeData && tradeData
                                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={index} selected={curTxIndex === index}>
                                            <TableCell>{moment(row.createdAt).format('L')}</TableCell>
                                            <Tooltip title={row._id} placement="top"><TableCell align='left'>{row._id}</TableCell></Tooltip>
                                            <TableCell align='left'>{row.user.firstName? row.user.firstName : ''}  {row.user.lastName ? row.user.lastName : ''}</TableCell>
                                            <TableCell align='left'>{row.asset}</TableCell>
                                            <TableCell align='left'>{row.counterAsset}</TableCell>
                                            <TableCell align='left'>{row.limitPrice}</TableCell>
                                            <TableCell align='left'>{row.orderType}</TableCell>
                                            <TableCell align='left'>{row.price}</TableCell>
                                            <TableCell align='left'>{row.quantity}</TableCell>
                                            <TableCell align='left'>{row.side}</TableCell>
                                            <TableCell align='left'>{row.status}</TableCell>
                                            <TableCell align='left'>
                                            {/* <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => handleOpenTxInfoDialog(row, index)}
                                            >
                                                <InfoIcon color="success"/>
                                            </IconButton> */}
                                            </TableCell>
                                        </TableRow>
                                        )
                                    )}
                                </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
        </div>}
        </>
    );
}

export default ExternalWalletTransactionTable;